<template>
  <div id="sp_one_module_4" class="sp1-group_68 flex-row justify-between" :style="sectionStyle">
    <div class="sp1-text-wrapper_2 flex-col" :style="titleStyle">
      <span class="sp1-text_6">{{ titleContent }}</span>
    </div>
    <div class="sp1-block_1 flex-col" :style="blockStyle">
      <div class="sp1-box_116 flex-row justify-between">
        <a
          v-for="(item, idx) in items"
          :key="idx"
          :class="['sp1-image-item', `sp1-image-item_${idx}`, { 'is-link': item.jumpType === 2 }]"
          :style="{ backgroundColor: itemBackgroundColor }"
          href="javascript:;"
          @click.prevent="handleClick(item)"
        >
          <img
            class="sp1-event-image"
            referrerpolicy="no-referrer"
            :src="item.imageUrl"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventSeries',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_4'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      titleContent: '系列活动',
      titleBackgroundColor: 'rgba(11, 115, 96, 1)',
      itemBackgroundColor: 'rgba(245, 245, 245, 1)',
      items: [
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG97e79262cc1e0a2a7a63f7e7786c4b39.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG97e79262cc1e0a2a7a63f7e7786c4b39.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/event/2'
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG6caad4959c577c6621dddf002edc963a.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG5d0afcd34128e1c76a754dcdce25ddb9.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/event/4'
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px'
      };
    },
    titleStyle() {
      return {
        backgroundColor: this.titleBackgroundColor
      };
    },
    blockStyle() {
      return {
        backgroundColor: this.itemBackgroundColor
      };
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-group_68 {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
}

.sp1-image-item {
  display: block;
  width: 294px;
  height: 211px;
  cursor: default;
  transition: opacity 0.2s;
  text-decoration: none;
}

.sp1-image-item.is-link {
  cursor: pointer;
}

.sp1-image-item.is-link:hover {
  opacity: 0.85;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.sp1-image-item:not(.is-link):hover {
  opacity: 0.9;
}

.sp1-image-item:nth-child(1) {
  margin-left: 0;
}

.sp1-image-item:not(:nth-child(1)) {
  margin-left: 21px;
}

.sp1-event-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
